import React from 'react';
import Text from 'components/Text/Text';
import { Checkbox, Form } from 'antd';
import style from './UseTLSCertificate.module.scss';

interface IProps {
	useTlsCertificate: boolean;
}

const UseTLSCertificate: React.FC<IProps> = ({ useTlsCertificate }) => {
	return (
		<Form.Item className={style.container}>
			<Checkbox checked={true} disabled={true}>
				<Text
					translationNameSpace="form"
					translationKey={
						useTlsCertificate ? 'useCertificateForDevicesIndividually' : 'clientTLSCertificateUsedLabel'
					}
					asFragment={true}
				/>
			</Checkbox>
		</Form.Item>
	);
};

export default React.memo(UseTLSCertificate);
